<template>
    <div class="flex flex-col max-w-screen-xl mx-auto px-8 lg:px-32 gap-y-4">
        <h1 class="text-2xl text-san-marino-600 font-semibold mt-4 lg:mt-24">
            Gizlilik Politikası
        </h1>
        <div class="text-san-marino-800 mt-2">
            <span class="font-semibold">Yürürlük Tarihi:</span> 22 Kasım 2024
        </div>
        <div class="text-san-marino-800 mt-2">
            LOKUM TECH LLC (“Kolay eSIM,” “biz,” “bize” veya “bizim”),
            gizliliğinize önem vermektedir. Bu Gizlilik Politikası, kişisel
            bilgilerinizi (kişisel veriler) nasıl topladığımız, kullandığımız,
            paylaştığımız ve koruduğumuz hakkında bilgi sunar. Ayrıca, bu
            bilgilerle ilgili haklarınız ve seçimleriniz ile bize nasıl
            ulaşabileceğiniz açıklanmaktadır.
        </div>
        <div class="text-san-marino-800 mt-2">
            Kolay eSIM hizmetlerini (web sitesi, uygulamalar, ürünler veya diğer
            araçlar) kullanarak veya bir hesap oluşturarak bu Gizlilik
            Politikasını anladığınızı ve kabul ettiğinizi onaylamış olursunuz.
        </div>
        <div class="text-lg text-san-marino-600 font-medium mt-4">
            Hangi Bilgileri Topluyoruz?
        </div>
        <div class="text-san-marino-800">
            Sizden doğrudan veya dolaylı olarak aşağıdaki bilgileri
            toplayabiliriz:
            <ul class="list-disc pl-8 mt-2">
                <li>
                    Kişisel Bilgiler: İsim, e-posta adresi, telefon numarası
                    gibi temel iletişim bilgileri.
                </li>
                <li>
                    Teknik Bilgiler: Web sitemizi veya hizmetlerimizi nasıl
                    kullandığınıza dair tarayıcı tipi, IP adresi ve çerezler
                    aracılığıyla toplanan bilgiler.
                </li>
                <li>
                    Konum Bilgisi: Hizmetlerin coğrafi olarak doğru şekilde
                    sunulabilmesi için sınırlı konum bilgileri.
                </li>
            </ul>
        </div>

        <div class="text-lg text-san-marino-600 font-medium mt-4">
            Bilgileri Nasıl Kullanıyoruz?
        </div>
        <div class="text-san-marino-800">
            Topladığımız bilgileri aşağıdaki amaçlarla kullanabiliriz:
            <ul class="list-disc pl-8 mt-2">
                <li>Siparişlerinizi işlemek ve hizmetlerimizi sunmak.</li>
                <li>
                    Kullanıcı deneyiminizi geliştirmek ve destek taleplerinizi
                    yanıtlamak.
                </li>
                <li>Dolandırıcılığı önlemek ve yasal yükümlülüklere uymak.</li>
                <li>
                    Promosyon ve pazarlama materyalleri göndermek (izin
                    verdiğiniz durumlarda).
                </li>
            </ul>
        </div>

        <div class="text-lg text-san-marino-600 font-medium mt-4">
            Bilgilerinizi Kimlerle Paylaşıyoruz?
        </div>
        <div class="text-san-marino-800">
            Kişisel bilgilerinizi aşağıdaki durumlarda paylaşabiliriz:
            <ul class="list-disc pl-8 mt-2">
                <li>
                    Hizmet Sağlayıcıları: Ödeme işleme, lojistik ve teknik
                    destek gibi hizmetler sunan iş ortaklarımızla.
                </li>
                <li>
                    Yasal Merciler: Yasal gerekliliklere uymak veya haklarımızı
                    korumak amacıyla.
                </li>
                <li>İzninizle: Özel durumlarda onayınızı alarak.</li>
            </ul>
        </div>

        <div class="text-lg text-san-marino-600 font-medium mt-4">
            Haklarınız Nelerdir?
        </div>
        <div class="text-san-marino-800">
            Bulunduğunuz bölgeye bağlı olarak, kişisel verilerinizle ilgili
            aşağıdaki haklara sahip olabilirsiniz:
            <ul class="list-disc pl-8 mt-2">
                <li>
                    Bilgilerinize erişme, düzeltme veya silme talebinde bulunma.
                </li>
                <li>
                    Veri işleme faaliyetlerine itiraz etme veya onayınızı geri
                    çekme.
                </li>
                <li>Kişisel verilerinizi taşınabilir bir formatta alma.</li>
            </ul>
        </div>

        <div class="text-lg text-san-marino-600 font-medium mt-4">
            Bilgilerinizi Nasıl Koruyoruz?
        </div>
        <div class="text-san-marino-800">
            Kişisel bilgilerinizi korumak için fiziksel, elektronik ve
            prosedürel güvenlik önlemleri uyguluyoruz. Ancak, internet üzerinden
            hiçbir veri iletim yönteminin tamamen güvenli olmadığını hatırlatmak
            isteriz.
        </div>

        <div class="text-lg text-san-marino-600 font-medium mt-4">
            Çocukların Gizliliği
        </div>
        <div class="text-san-marino-800">
            Hizmetlerimiz, 16 yaşın altındaki bireylere yönelik değildir.
            Bilinçli olarak bu yaş grubundan bilgi toplamıyoruz.
        </div>

        <div class="text-lg text-san-marino-600 font-medium mt-4">
            Çerezler ve İzleme Teknolojileri
        </div>
        <div class="text-san-marino-800">
            Web sitemizi kullanırken deneyiminizi iyileştirmek için çerezler ve
            benzeri izleme teknolojilerini kullanabiliriz. Çerez ayarlarınızı
            tarayıcınız üzerinden yönetebilirsiniz.
        </div>

        <div class="text-lg text-san-marino-600 font-medium mt-4">
            Gizlilik Politikasındaki Değişiklikler
        </div>
        <div class="text-san-marino-800">
            Bu Gizlilik Politikasını zaman zaman güncelleyebiliriz. Önemli
            değişiklikler yapılması durumunda, bu sayfada veya size doğrudan bir
            bildirim yoluyla değişiklikleri duyuracağız.
        </div>

        <div class="text-lg text-san-marino-600 font-medium mt-4">
            İletişim Bilgileri
        </div>
        <div class="text-san-marino-800 mb-24">
            Gizlilik uygulamalarımız hakkında sorularınız veya endişeleriniz
            varsa, bizimle iletişime geçmekten çekinmeyin:
            <ul class="list-disc pl-8 mt-2">
                <li>E-posta: destek@kolayesim.com</li>
                <li>Telefon: +90 532 270 37 46</li>
            </ul>
        </div>
    </div>
</template>

<script setup lang="ts">
useSeoMeta({
    title: "Gizlilik Politikası",
    description: "Kolay eSIM'in gizlilik politikası",
});
</script>
